import { useBemCN } from '@gik/core/utils/bemBlock';
import React from 'react';

export interface IArticleComponentCreditsProps {
  caption: string;
  credit: string;
  creditLink: string;
}

const blockName = 'article-component-credits';

export function ArticleComponentCredits({ caption, credit, creditLink }: IArticleComponentCreditsProps) {
  const bem = useBemCN(blockName);

  return (
    <div {...bem()}>
      <p {...bem('caption')}>{caption}</p>
      <p {...bem('credit')}>
        {credit} {creditLink && ' - '} {creditLink && <a href={creditLink}>link</a>}
      </p>
    </div>
  );
}
